import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { Cin7ProductAvailability } from "@/api/dtos";

interface ProductAvailabilityListResponse {
  Total: number;
  Page: number;
  ProductAvailabilityList: Cin7ProductAvailability[];
}

const PAGE_LIMIT = 500;

/** Cin7 product availability at the eStore location, first page of up to 500 (via the backend Cin7 proxy); raw Cin7 rows. */
export const getProductAvailabilityApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProductAvailability: builder.query<Cin7ProductAvailability[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<ProductAvailabilityListResponse>(
            `${backendBase()}/cin7/product-availability`,
            {
              params: { Page: 1, Limit: PAGE_LIMIT, Location: "estore" },
              headers: { Accept: "application/json" },
            },
          );
          return { data: res.data.ProductAvailabilityList };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
    }),
  }),
});

export const getProductAvailability = getProductAvailabilityApi.endpoints.getProductAvailability;
